import { useEffect, useState } from "react";
import { QuickbooksCallbackViewModel } from "../../viewmodels/quickbooks/QuickbooksCallbackViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";

import SimpleNotification from "../../components/SimpleNotification";
import { set } from "date-fns";
import { tr } from "date-fns/locale";

function QuickbooksCallbackScreen(props) {
  const { logout } = props;
  const {
    emptyModal,
    setEmptyModelOpen,
    setShowSimpleNotification,
    onStartCallback,
    showSimpleNotification,
  } = QuickbooksCallbackViewModel(logout);

  useEffect(() => {
    const search =
      typeof window !== "undefined" ? window.location.search : null;

    const params = {};
    const searchParams = new URLSearchParams(search);
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const realmId = searchParams.get("realmId");
    params.code = code;
    params.state = state;
    params.realmId = realmId;
    // Pass parsed params (may be empty) to the viewmodel handler
    onStartCallback(params);
  }, []);

  return (
    <div>
      <div className="mt-2 mx-4"> Quickbooks connection in progress...</div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QuickbooksCallbackScreen),
);
